import Vue from 'vue'
import VueRouter from "vue-router"
// import HelloWorld from './components/HelloWorld'
import Home from './views/Home'
import Profile from './views/Profile'
import Skill from './views/Skill'
import Portfolio from './views/Portfolio'
import Social from './views/Social'
import Contact from './views/Contact'
// import Test from './views/Test'

Vue.use(VueRouter)

const routes = [
    { path: '/home', component: Home},
    { path: '/', component: Home},
    { path: '/profile', component: Profile},
    { path: '/skill', component: Skill},
    { path: '/portfolio', component: Portfolio},
    { path: '/social', component: Social},
    { path: '/contact', component: Contact},
    // { path: '/test', component: Test},
]

const router = new VueRouter({
    routes: routes
})

export default router